/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_DISCOUNT_CODES = gql`
 query GetAllDiscountCodes($filter: DiscountCodesFilterInput, $options: GetManyOptions) {
  getAllDiscountCodes(filter: $filter, options: $options) {
    count
    skip
    limit
    content {
      _id
      adminId {
        email
      }
      committeeId {
        email
      }
      masqId {
        email
      }
      createdBy {
        email
      }
      discountCodes {
        discountCode
        status
      }
      discountType
    }
  }
}
`;
